/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadCareAttributesRequest
 */
export interface UpdateLeadCareAttributesRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributesRequest
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributesRequest
     */
    category: UpdateLeadCareAttributesRequestCategoryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLeadCareAttributesRequest
     */
    care_attribute_ids: Array<string>;
}


/**
 * @export
 */
export const UpdateLeadCareAttributesRequestCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care'
} as const;
export type UpdateLeadCareAttributesRequestCategoryEnum = typeof UpdateLeadCareAttributesRequestCategoryEnum[keyof typeof UpdateLeadCareAttributesRequestCategoryEnum];


/**
 * Check if a given object implements the UpdateLeadCareAttributesRequest interface.
 */
export function instanceOfUpdateLeadCareAttributesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "care_attribute_ids" in value;

    return isInstance;
}

export function UpdateLeadCareAttributesRequestFromJSON(json: any): UpdateLeadCareAttributesRequest {
    return UpdateLeadCareAttributesRequestFromJSONTyped(json, false);
}

export function UpdateLeadCareAttributesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadCareAttributesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'category': json['category'],
        'care_attribute_ids': json['care_attribute_ids'],
    };
}

export function UpdateLeadCareAttributesRequestToJSON(value?: UpdateLeadCareAttributesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_id': value.lead_id,
        'category': value.category,
        'care_attribute_ids': value.care_attribute_ids,
    };
}

